import { createAction } from '@reduxjs/toolkit';

export const FETCH_IN_DISPOSITIONS_ACTION_TYPE = 'saga/fetchInDispositions';
export const fetchInDispositionsAction = createAction(FETCH_IN_DISPOSITIONS_ACTION_TYPE);
